import vanessaPic from "@/public/images/artists/vanessa.png";
import { Artist } from "@/types/types";

export const vanessa = {
  id: "211",
  name: "Vanessa",
  image: vanessaPic,
  description: `Vanessa's voice is incredibly airy, with an exceptional falsetto. Her sultry, emotionally charged tone is perfect for talk-singing, where her unique delivery creates a raw and intimate feel.`,
  previewUrl:
    "https://public-assets.audimeestorage.com/artistPreviews%2Fvanessa-preview.mp3",
  meta: {
    free: false,
    new: false,
  },
  filters: {
    gender: "Female",
    tags: {
      primary: ["Airy", "Falsetto", "Ballads", "Pop", "Dance", "Ethereal"],
      secondary: [],
    },
    pitchRange: {
      categories: {
        low: "High",
        high: "Very high",
      },
      specific: {
        low: 57,
        high: 74,
      },
      sweetSpot: 62,
    },
  },
} as const satisfies Artist;
